import React from 'react';
import PricingCards from 'components/payment/PricingCards.jsx';

// The download / redraw-denied paywall previously rendered a row table of the
// retired bronze monthly / annual plans. It now delegates to PricingCards, so
// every paywall sells the same Starter / Business / Business Plus tiers (plus
// the credit packs, unless hideCredits) and no bronze plan is offered anywhere.
// Kept as a thin wrapper so the several call sites that render <PricingTables>
// (redraw_denied, quote-builder and download-section paywalls) keep working.
const PricingTables = ({ setMode, setSubscription, setCurrencyName, hideCredits, currencySelector, disabledTiers, disabledTierNote }) => (
  <PricingCards
    setMode={setMode}
    setSubscription={setSubscription}
    setCurrencyName={setCurrencyName}
    hideCredits={hideCredits}
    currencySelector={currencySelector}
    disabledTiers={disabledTiers}
    disabledTierNote={disabledTierNote}
  />
);

export default PricingTables;
